<template>
    <nav class="navbar navbar-transparent navbar-color-on-scroll fixed-top navbar-expand-lg p-0" color-on-scroll="100"
         id="sectionsNav">
        <div class="container-fluid">
            <div class="navbar-translate">
                <router-link to="/">
                    <img src="../../public/assets/img/gtl_white.png" class="img-fluid ml-sm-4 cursor-pointer"
                         style="width:70px" alt/>
                    <span class="text-orange text-center"> <b>Employability Portal</b></span>
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span class="sr-only">Toggle navigation</span>
                    <span class="navbar-toggler-icon"/>
                    <span class="navbar-toggler-icon"/>
                    <span class="navbar-toggler-icon"/>
                </button>
            </div>
            <div class="collapse navbar-collapse">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item dropdown" v-if="$store.getters.loggedIn">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">
                            <img v-lazy="'/assets/img/user.png'" alt="Company Image" class="img-size-32 img-circle">
                            {{($store.state.userInfo ||{}).company_name}}
                        </a>
                        <div class="dropdown-menu dropdown-menu-right">
                            <router-link to="/company/dashboard" class="dropdown-item">
                                Dashboard
                            </router-link>
                            <router-link to="/logout" class="dropdown-item">
                                Logout
                            </router-link>
                        </div>
                    </li>
                    <!-- <li class="nav-item">
                        <a class="nav-link" href="javascript:void(0)">
                            Job & Skills Resource Portal
                        </a>
                    </li> -->
                </ul>
                <ul class="navbar-nav pt-2" v-if="!$store.getters.loggedIn">
                    <li class="p-2">
                        <router-link class="nav-link btn btn-green" to="/login">Login as company</router-link>
                    </li>
                    <li class="p-2">
                        <router-link class="nav-link btn btn-orange" to="/register">Register as company</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

</template>

<script>
    // import Swal from 'sweetalert2';
    export default {
        name: "TransparentNavbar",
        created() {
        },
        methods:{
            // checkLoginType(to) {
            //     if (this.$store.state.type == 'company' && to == '/internship') {
            //         Swal.fire({
            //             title: "Info!",
            //             text: "Sorry, you are already logged in as a company",
            //             icon: "info",
            //             confirmButtonText: "Proceed to dashboard",
            //             showCancelButton: true,
            //         }).then((result) => {
            //             if (result.isConfirmed) {
            //                 this.$router.push('/company/home')
            //             }
            //         });
            //     } else if (this.$store.state.type == 'intern' && to == '/company/home') {
            //         Swal.fire({
            //             title: "Info!",
            //             text: "Sorry, you are already logged in as an intern",
            //             icon: "info",
            //             confirmButtonText: "Proceed to company dashboard",
            //             showCancelButton: true,
            //         }).then((result) => {
            //             if (result.isConfirmed) {
            //                 this.$router.push('/internship')
            //             }
            //         });
            //     } else {
            //         this.$router.push(to);
            //     }
            // }

        }
    };
</script>

<style scoped>
    .navbar {
        border: 0;
        border-radius: 3px;
        padding: 0.625rem 0;
        margin-bottom: 20px;
        color: #0599a9;
        background-color: #fff !important;
        box-shadow: 0 4px 18px 0px rgba(0, 0, 0, 0.12),
        0 7px 10px -5px rgba(0, 0, 0, 0.15);
        font-family: gotham;
    }

    .navbar.navbar-transparent {
        /*border-bottom: 1px solid var(--grey);*/
        background: transparent !important;
        /*height: 10%;*/
        /*color: white !important;*/
    }

    @media (max-width: 991px) {
        .navbar-collapse .navbar-nav .nav-item .nav-link {
            color: black !important;
        }
    }

    .navbar-transparent .nav-item .nav-link{
        color: white !important;
    }
    .dropdown-item:hover{
        color:white !important;
    }

    .navbar .nav-item a {
        color: black;
    }

    .navbar {
        box-shadow: none !important;
    }

    .nav-item a {
        color: black !important;
        font-family: var(--gotham);
        font-size: 17px !important;
        /*font-weight: 600 !important;*/
        text-transform: none !important;
    }

    @media screen and (max-width: 991px) {
        .nav-item a {
            color: black !important;
        }

        .navbar .navbar-toggler .navbar-toggler-icon {
            background-color: white !important;
        }
    }
</style>
